import { ShortcutAwareTooltip } from 'common/Prose/utils/ShortcutAwareTooltip'
import { Button } from './Button'
import { observer } from 'mobx-react-lite'
import { useRedoToggle } from 'common/Prose/Toolbar/hooks/useRedoToggle'
import { FlipRight } from 'blaze-ui/icons'
import { Icon } from 'blaze-ui/icons/Types'

export const RedoButton = observer(({ icon = FlipRight }: { icon?: Icon }) => {
  const { disabled, handleClick } = useRedoToggle()

  return (
    <ShortcutAwareTooltip label="Redo" shortcutModifiers={['Mod', 'Shift']} shortcutKeys="z">
      <Button aria-label="Redo" icon={icon} isDisabled={disabled} onPress={handleClick} />
    </ShortcutAwareTooltip>
  )
})
